import gql from 'graphql-tag';

export const GET_RESEARCH_EXPERIENCE = gql`
  query ($id: ID!) {
    researchExperience(id: $id) {
      pastResearchExperience
      proposedResearchTopic
      proposedResearchPlan
      reasons
      longTermCareerPlan
      expectedContribution
      others
      researchProposal
    }
  }
`;
